import { Module } from 'wrapper6'

const $ = jQuery

export default class FadeImages extends Module {
  ready (app) {
    this.fadeImages()
  }

  fadeImages () {
    const images = document.querySelectorAll('.faded-out')

    if (images.length) {
      for (let i = 0; i < images.length; i++) {
        const image = images[i]

        image.classList.add('fade-in')
        image.classList.remove('faded-out')
      }
    }
  }
}
